import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-navigator"
export default class extends Controller {
  navigate(event) {
    const selection = event.target.selectedOptions[0]

    if (selection && selection.dataset.url) {
      window.location = selection.dataset.url
    }
  }
}
